import { safeHTML } from '../../../../../utils/safeHTML';
import { useTranslation } from '../../../../../translations';

export default function Header({ title, description }) {
  const { t } = useTranslation();

  return (
    <>
      {title && <h2 className={'info-modal__title'}>{safeHTML(t(title))}</h2>}
      {description && <p className={'info-modal__text'}>{safeHTML(t(description))}</p>}
    </>
  );
}
